import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFirestore, Firestore } from 'firebase/firestore';

// Firebase configuration using environment variables
// These will be set in Vercel dashboard - DO NOT commit actual values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDCVE9cXpOXhJJmq85lE6YoYXb55To3r7g",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "car-rental-admin-2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "car-rental-admin-2",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "car-rental-admin-2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "244918354018",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:244918354018:web:b37ef3609d421be1efd13b",
};

// Validate that all required environment variables are present
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID',
];

const missingEnvVars = requiredEnvVars.filter(envVar => !process.env[envVar]);

if (missingEnvVars.length > 0) {
  console.warn('Using fallback Firebase configuration. For production, set these environment variables:', missingEnvVars);
  console.warn('Please configure these in your Vercel dashboard or .env.local file');
}

// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;
let storage: FirebaseStorage;
let db: Firestore;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  storage = getStorage(app);
  
  // Initialize Firestore with the specific database ID
  // Since you created 'rentaldb2' in us-central1, we need to specify it
  db = getFirestore(app, 'rentaldb2');
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  throw error;
}

export { auth, storage, db };

export default app;
